// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2020-05-19T18:01:38Z                      #

// ##############################################################

export function updateBankovniUcet_12185C(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'BankovniUcetVO',
    };


    return result;
}

export function updateMapBankovniUcet_12185C(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateBankovniUcet_12185C(data[key]);
    });
    return result;
}

export function updateListBankovniUcet_12185C(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateBankovniUcet_12185C);
}

export function updateHlavickaPlatbaFilter_642BF1(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.bankovniUcet !== "undefined") {
        result.bankovniUcet = updateBankovniUcet_12185C(data.bankovniUcet);
    }

    return result;
}

export function updateMapHlavickaPlatbaFilter_642BF1(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateHlavickaPlatbaFilter_642BF1(data[key]);
    });
    return result;
}

export function updateListHlavickaPlatbaFilter_642BF1(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateHlavickaPlatbaFilter_642BF1);
}
